/**
 * @Author: Anandp
 * @Date:   2024-04-17 18:40:50
 * @Last Modified by:   Anandp
 * @Last Modified time: 2024-12-23 16:27:42
 */
import React, { useEffect } from "react";
import { Backdrop, Checkbox, CircularProgress, FormControlLabel, FormGroup} from "@mui/material";
import { ReactComponent as SmartLeaderLogo } from "../../icons/untitled-ui/smartLeaderWhite.svg";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
// import SurveyTile from "./surveys/surveyCards";
import { RouterLink } from "src/components/router-link";
// import surveyAPIService from "src/services/surveyApi";
import surveyAPIService from "src/services/surveyApi";
import { useState } from "react";
import { createTypography } from "src/theme/base/customTypography";
import ExecutiveHealthSurveyTile from "./components/surveyCards";
import loginApiService from "src/services/loginAPI";
import * as SldButtons from "src/theme/base/SldButtons";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import * as SldSurveyCard from "src/theme/base/SldSurveyCard";
import LinkExpired from "../wiredUpSurveys/surveys/linkExpire";
import { useAuth } from "src/hooks/use-auth";
// import { createTypography } from "../../theme/base/customTypography";




/**
 * Component renders executive health survey start page
 *
 *@module ExecutiveHealthSurveyStartPage
 * @param {object} props - Component properties.
 * @returns {JSX.Element} The rendered component.
 */
function ExecutiveHealthsurveyStartPageLayout(props) {
  const { children } = props;
  // const id = 7;
  // eslint-disable-next-line
  const token = "tokenuser";
  // const sectionPage = 1;

  const accesssToken = sessionStorage.getItem("accessToken");
  const queryParameters = new URLSearchParams(window.location.search);
  const surveyId = queryParameters.get("surveyId");
  const [inviteId, setInviteId] = useState(null);
  const [isLoading ,setIsLoading] = useState(true);
  const emailToken = queryParameters.get("token");
  const emailInviteId= queryParameters.get("inviteId")
  const [isAcknowledge,setIsAcknowledge] = useState(false)
  const [valid, setValid] = useState(0);
  const { initialize } = useAuth();
  const CheckIsAcknowledge =()=>{
    setIsAcknowledge(!isAcknowledge)
  }

  /**
   * On mount: if the user navigated here while already logged in (session exists
   * in storage), pre-initialize the auth context. This ensures that pressing the
   * browser back button to a protected route doesn't trigger a redirect to sign-in
   * due to a race condition where AuthGuard sees isAuthenticated=false.
   */
  useEffect(() => {
    const issuer = localStorage.getItem('issuer');
    const userDetails = sessionStorage.getItem('userDetails');
    if (issuer && userDetails) {
      initialize();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**
   * Function to get invite id , If no invite id is present new invite id will be created
   * @date 11/5/2023 - 12:07:16 AM
   *
   * @async
   * */
  const getInviteId = async () => {
    try {
      const inviteIdGetData = {
        survey_id: surveyId,
        inviteId: inviteId,
        timeStamp: "",
        teamId: "",
      };
      //api call to check invite id
      const response = await surveyAPIService.checkInviteId(
        inviteIdGetData,
        accesssToken
      );
      setInviteId(response.data.inviteId);
      setIsLoading(false)
    } catch (error) {}
  };
  /**
   * Function to validate the token which get from survey link
   *
   * @async
   * @returns {*} 
   */
  const validateToken = async() =>{
    try {
      const response = await loginApiService.decodeToken(emailToken);
      if(response?.userId){
        const stringifiedUser = JSON.stringify(response)
      sessionStorage.setItem("userDetails", stringifiedUser);
      setInviteId(emailInviteId);

      // Pre-initialize auth context so that pressing back to a protected
      // route doesn't redirect to sign-in (AuthGuard race condition fix).
      localStorage.setItem('issuer', 'jwt');
      await initialize();
      }
      

    } catch (error) {
      console.log(error);
      
    }
  }
  /**
 * Validates the survey invitation link using the provided email token and invite ID.
 * Updates the validation state based on the response.
 *
 * @async
 * @function validateLink
 * @returns {Promise<void>}
 */
  const validateLink = async () => {
    try {
      const response = await loginApiService.validateLink(emailToken, inviteId);
      setValid(response[0].is_complete);
      setIsLoading(false)
    } catch (error) {

    }
  }
  useEffect(() => {
    if (inviteId && emailInviteId &&  emailToken) {
      validateLink();
    }
    // eslint-disable-next-line
  }, [inviteId,emailInviteId,emailToken])
  useEffect(()=>{
    if(emailInviteId &&  emailToken){
      validateToken()
    }
    else{
      getInviteId()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[emailInviteId,emailToken])
  const typography = createTypography();
  // useEffect(()=>{
  //   if(inviteId){
  //     setIsLoading(false)
  //   }
  // },[inviteId])
  if (isLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  if (valid === 1) {
    return <LinkExpired />;
  }
  return (
<SldSurveyCard.SurveyGrid
      container
      spacing={0}
      
    >
      <SldSurveyCard.SurveyGridItem
        item
        lg={12}
        sm={12}
      >
        <SldSurveyCard.SurveyLogo>
          <SmartLeaderLogo width='250' />
        </SldSurveyCard.SurveyLogo>
      <Stack
        justifyContent="space-between"
        alignItems="center"
        spacing={6}>
          <Typography sx={typography.qNheading}>
            My Executive Health Questionnaire
          </Typography>
          <SldButtons.SurveyClock 
            variant="contained">
          <AccessTimeIcon />
            <Typography variant="subtitle1"> Duration <span>20 mins</span></Typography>
          </SldButtons.SurveyClock>
          
        </Stack>
      </SldSurveyCard.SurveyGridItem>
      <SldSurveyCard.SurveyStack
    spacing={3}
    
    sx={{
      marginTop:{lg :'-140px', sm :'5px', xs :'3px'},
      padding:{lg:'0 60px', md:'0 60px', sm:'0 0', xs:'0'},
    }}
  >
      <ExecutiveHealthSurveyTile />
      <SldSurveyCard.SurveyRules 
      lg={12} 
     >
        <SldSurveyCard.SurveyContainer>{children} </SldSurveyCard.SurveyContainer>
        {/* </SurveyStack> */}
        <FormGroup 
        sx={{alignItems : "flex-start" , justifyContent:"center", padding:4,
            "& .MuiFormControlLabel-root":{alignItems:'flex-start'},
            '& .MuiTypography-root':{paddingTop:1},
            '& .MuiFormControlLabel-asterisk':{display:'none'},
            '& .MuiCheckbox-root':{paddingTop:'0'} 

            
        }}>
          <FormControlLabel  required 
          control={<Checkbox onClick={()=>CheckIsAcknowledge()} 
          sx={{ }}
          />} 
          label="I agree to ISL using my data for research on Executive Health in a combined form with data of others in an anonymous unrecognisable ‘grouped’ form." />
        </FormGroup>
        {/* <Typography>Yes, I agree with you</Typography> */}
        <SldButtons.WhiteButtonCap disabled ={!isAcknowledge} 
        endIcon={<ArrowForwardIcon />}
            variant="contained"
            component={RouterLink}
            to={`/surveyQuestions?id=${surveyId}&inviteId=${inviteId}`}
          >
            <Typography sx={typography.startButton}>Start</Typography>
            </SldButtons.WhiteButtonCap> 
      </SldSurveyCard.SurveyRules >
      </SldSurveyCard.SurveyStack>
      </SldSurveyCard.SurveyGrid>
  );
}


export default ExecutiveHealthsurveyStartPageLayout;
